/**
 * Turns anything thrown into something worth showing a user.
 *
 * The `instanceof Error` check that this replaces silently swallowed every
 * database failure: supabase-js does not throw Error instances. A
 * PostgrestError is a plain object -- { message, details, hint, code } -- so
 * the check was always false and every backend problem, from a missing column
 * to an RLS rejection, surfaced as the same generic fallback.
 *
 * The full error also goes to the console, because `hint` and `code` are what
 * actually identify a Postgres failure and they do not belong on screen.
 */
export function errorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    // eslint-disable-next-line no-console
    console.error(err);
  }

  if (err instanceof Error && err.message.trim() !== '') return err.message;

  if (err && typeof err === 'object') {
    const e = err as { message?: unknown; hint?: unknown };
    const message = typeof e.message === 'string' ? e.message.trim() : '';
    const hint = typeof e.hint === 'string' ? e.hint.trim() : '';
    if (message && hint) return `${message} (${hint})`;
    if (message) return message;
  }

  if (typeof err === 'string' && err.trim() !== '') return err;

  return fallback;
}
